import { ErrorData } from './error-data';
import { CellRow } from './interfaces/component.interface';
import { DataMap } from './interfaces/data-map';
import { TabData } from './tab-data';

/**
 * @param {isLoading} while component data is loading, success should be false, should show a spinner on web and wait until data is loaded
 * @param {error} errorData object
 * @param {success} success should be true only when component data is not loading, there is no error object associated and tabs get meaningful data
 */
export class ComponentData {
	public readonly tab: DataMap<TabData>;
	public static create(options: ComponentDataOptions): ComponentData {
		return new ComponentData(options.id, options.tabs, options.portfolioData, options.isLoading, options.error, options.success, options.visible);
	}

	constructor(
		public readonly id: string,
		public readonly tabs: TabData[],
		public readonly portfolioData: CellRow[] = [],
		public isLoading: boolean = true,
		public error?: ErrorData,
		public success: boolean = false,
		public visible: boolean = true
	) {
		// Populate tab object that can be accessed as a map
		this.tab = {};
		let i = 0;
		for (const tab of this.tabs) {
			let id = String(i);
			if (!tab.id) {
				console.warn(`Component ${this.id} tab #${i} doesn't have an ID set.`);
			} else {
				id = tab.id;
			}
			if (this.tab[id]) {
				throw new Error(`Component ${this.id} has duplicate tab ID ${id} at position ${i}`);
			} else {
				this.tab[id] = tab;
			}
			i++;
		}
	}

	public getTabById(id: string): TabData {
		return this.tabs && this.tabs.find(tab => tab.id === id);
	}
}

export interface ComponentDataOptions {
	id: string;
	tabs: TabData[];
	portfolioData: CellRow[];
	isLoading: boolean;
	error?: ErrorData;
	success: boolean;
	visible: boolean;
}
